<template>
  <div class="product__info-card">
    <div class="product__info-body">
      <div class="product__badge tag-badge " 
        :class="promotion_meta.color == '' ? 'tag-badge--sale' : ''" 
        v-if="promotion_meta.text != ''" 
        :style="'background: ' + promotion_meta.color + ';'">{{ promotion_meta.text }}</div>
      <div class="product__prices-stock">
        <div class="product__prices">
          <div class="product__price product__price--current" v-if="priceDisplay != ''">{{ priceDisplay }}</div>
          <div class="product__price--core" v-if="product.coreprice > 0">
            +${{ product.coreprice }} Refundable Core Deposit
          </div>
        </div>
      </div>
      <div class="in-stock">
        <div class="status-badge status-badge--style--success product__stock status-badge--has-text">
          <div class="status-badge__body">
            <div class="status-badge__text">
              <availability-display :stock-quantity="product.stockquantity" :backordered="false" />
            </div>
            <div
              class="status-badge__tooltip"
              tabindex="0"
              data-toggle="tooltip"
              title="In&#x20;Stock"
            ></div>
          </div>
        </div>
      </div>
      <div class="product__meta">
        <table>
          <tr>
            <th>Item</th>
            <td>{{ product.sku }}</td>
          </tr>
          <tr>
            <th>Manufacturer</th>
            <td>{{ product.manufacturername }}</td>
          </tr>
          <tr v-if="isCapaCert == true">
            <th>Certification</th>
            <td>CAPA Certified</td>
          </tr>
          <tr v-if="product.listprice > 0">
            <th>List Price</th>
            <td class="notranslate">{{ toUSD(product.listprice) }}</td>
          </tr>
          <tr v-if="xRef">
              <th>X-Ref ({{ product.xref_mfg_desc }})</th>
              <td>{{ product.XRITMC }}</td>
          </tr>
          <tr v-if="isPartPartslink == true">
            <th>Years</th>
            <td></td>
          </tr>
          <tr v-if="isPartPartslink == true">
              <th>OE Number</th>
              <td></td>
          </tr>
          
          <!-- <tr v-if="isPartPartslink == true">
              <th>Labor</th>
              <td></td>
          </tr> -->
          <!-- <tr>
              <th>X-Ref (Atlantic & Pacific)</th>
              <td>{{ product.XRMFGC }}</td>
          </tr> -->
        </table>
      </div>
    </div>
    <div class="product__actions">
      <div class="product__actions-item product__actions-item--quantity">
        <div class="input-number">
          <input
            class="input-number__input form-control form-control-lg"
            type="number"
            min="1"
            :value="modelValue"
            @change="$emit('update:modelValue', $event.target.value)"
          />
          <div class="input-number__add" @mousedown.left="startChange('add')" @mouseup="stopChange" @mouseleave="stopChange"></div>
          <div class="input-number__sub" @mousedown.left="startChange('sub')" @mouseup="stopChange" @mouseleave="stopChange"></div>
        </div>
      </div>
      <div class="product__actions-item product__actions-item--addtocart">
        <button class="btn btn-primary btn-lg btn-block" @click="addToCart()">Add to Cart</button>
      </div>
      <div class="product__actions-divider"></div>
    </div>
    <div class="product__tags-and-share-links">
      <!-- <div class="product__tags tags tags--sm">
        <div class="tags__list">
          <a href="" v-for="tag in product.tags" :key="tag">{{tag}}</a>
        </div>
      </div> -->
      <!-- <div class="product__share-links share-links">
        <ul class="share-links__list">
          <li class="share-links__item share-links__item--type--like">
            <a href="#">Share on Facebook (x)</a>
          </li>
          <li class="share-links__item share-links__item--type--tweet">
            <a href="#">Tweet (x)</a>
          </li>
        </ul>
      </div> -->
    </div>
  </div>

  <add-to-cart-dialog :open="hasAdded" @close="hasAdded = false" 
      :item_name="added_to_cart.item_name" 
      :item_image="added_to_cart.item_image"
      :quantity="added_to_cart.quantity">
  </add-to-cart-dialog>
</template>

<script>
import Price from '../../../mixins/price.js';
import AvailabilityDisplay from '../orderparts/AvailabilityDisplay.vue';
import AddToCartDialog from '../../common/product/AddToCartDialog.vue';
import Cloudinary from '../../../utilities/cloudinary';
import { mapGetters } from 'vuex';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';

export default {
    components: {
        "availability-display": AvailabilityDisplay,
        "add-to-cart-dialog" : AddToCartDialog
    },
    props : {
        product : {
            type : Object
        },
        prevRoute : {
            type : String
        },
    },
    mixins: [Price],
    data() {
        return {
            interval: false,
            timeout: 0,
            modelValue : 1,

            // add to cart dialog properties
            hasAdded: false,
            added_to_cart : {
                item_name: '',
                quantity : 1,
                item_image: '',
            },

            promotion_meta: {
              text: '',
              color: '',
            }
        }
    },
    computed: {
      ...mapGetters([
        "storeCatalog"
      ]),
      isCapaCert() {
        // console.log(this.prevRoute);
        if (this.prevRoute !=  "SearchResults"){
          return false;
        }

        // console.log(this.storeCatalog);
        if (this.storeCatalog !=  'PARTSLINK'){
          return false;
        }

        // if product property is not existing yet
        // return false
        if (this.product.sku == undefined){
          return false;
        }

        // get the last character of the product SKU
        const itemsku = this.product.sku;
        const isCapa = itemsku.slice(-1);

        if(isCapa == 'C')
          return true;
        else
          return false;
      },
      isPartPartslink() {
        if (this.prevRoute !=  "SearchResults"){
          return false;
        }

        if (this.storeCatalog !=  'PARTSLINK'){
          return false;
        }

        return true;
      },
      priceDisplay() {
        // if (this.$store.getters.customerIndicator === 'B') {
        //   return this.toUSD(this.product.listprice);
        // } else {
          return this.toUSD(this.product.price);
        // }
      },

      xRef() {
        const ECDXR = this.$store.getters.custInfoEnrolled;
        if (ECDXR == ''){
          return false;
        }

        if (this.product.xref_mfg_desc == ''){
          return false;
        }

        return true;
      },

      
    },
    methods: {
        startChange(form) {
            if (!this.interval) {
                this.interval = setInterval(() => {
                    let qty = 0
                    if (!isNaN(parseInt(this.modelValue))) {
                        qty = parseInt(this.modelValue)
                    }
                    if (form === 'add') {
                        qty += 1;
                    } else {
                        qty = (qty - 1 < 0) ? qty = 0 : qty - 1;
                    }
                    this.modelValue = qty;
                }, 100)
            }
        },

        stopChange() {
            clearInterval(this.interval);
            this.interval = false;
        },

        addToCart() {

          let linetotal = 0;
          
          // if (this.$store.getters.customer === 'DMS') {
          if (this.$store.getters.customerIndicator === 'B') {
            linetotal = this.modelValue * this.product.listprice;
          } else {
            linetotal = this.modelValue * this.product.price;
          }
          
          const clImage = Cloudinary.image(this.product.gallery[0].publicId);

          let productData = {
            ID: this.product.sku,
            item: this.product.sku,
            desc: this.product.desc,
            manufacturer: this.product.manufacturer,
            image: clImage.toURL(),
            quantity: this.modelValue,
            listprice: this.product.listprice,
            corecharge: this.product.coreprice,
            yourprice: this.product.price,
            shipping: 0,
            linetotal: linetotal,
            stockquantity: this.product.stockquantity,
            location: this.product.location,

            // new fields
            XRMFGC: this.product.XRMFGC,
            XRITMC: this.product.XRITMC,
            IMIGSA: this.product.IMIGSA,
            IMISVALID: this.product.IMISVALID,
          }

          this.$store.dispatch("cart/addToCart", productData);

          setTimeout(() => {
              // console.log(this.product);
              this.added_to_cart = {
                  item_name: this.product.manufacturer + ' ' + this.product.desc + ' ' + this.product.sku,
                  quantity : this.modelValue,
                  item_image: clImage.toURL(),
              }
              console.table(this.added_to_cart);
              this.hasAdded = true;
          }, 500);
          
        },

        promotion_text(){
          // let metadata_ptext = 'SALE';

          const clApi = new CloudinaryApi;
          // console.log(this.$route.params.manufacturer);
          // console.log(this.$route.params.partnumber);
          // large image
          clApi.vlLatestProducts(GCONST.CL_METARTYPE_FEATURED).then(images => {
              // console.log(images);

              images.forEach(img => {
                // console.log(img);
                if(img.metadata.itemsku == this.$route.params.partnumber && img.metadata.mfgcode == this.$route.params.manufacturer){
                  this.promotion_meta =  {
                    text: img.metadata.promotion_text,
                    color: img.metadata.promotion_color,
                  }
                }
              });
              
          });
      }
    },
    created() {
      this.promotion_text();
    },
    updated() {
    //  console.log(this.product);
    }

}
</script>